export enum SelectionMenuViewMode {
  EDIT = 'EDIT',
  VIEW = 'VIEW',
}

export interface SelectionMenuConfig {
  maxWidth: number;
  maxHeight: number;
  hasSearch?: boolean;
}

export interface ButtonBaseWithSelectionMenuProps {
  viewMode: SelectionMenuViewMode;
  disabledTooltipLabel?: string;
  renderMenuContent: (props: RenderMenuContentProps) => React.ReactNode;
  buttonContent: React.ReactNode;
  disabled?: boolean;
  isLoadingButton?: boolean;
  isFocusable?: boolean;
  menuConfig?: SelectionMenuConfig;
  onClickOpen?: (event: React.MouseEvent<HTMLElement>) => void;
  onClose?: () => void;
  testId?: string;
}

interface RenderMenuContentProps {
  closeMenu: () => void;
  anchorEl: HTMLElement | null;
  updatePosition: () => void;
}
